import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCardApplicaions',
  pure: false
})
export class FilterCardApplicaionsPipe implements PipeTransform {

  transform(value: Array<Object>, prop:any[]): any {
    return value.filter(v=>prop.indexOf(v['cardApplicationStatus']) != -1);
  }

}